var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-editor"},[(_vm.showDashboard)?_c('div',{staticClass:"main-editor-header"},[_c('MainTopNav')],1):_vm._e(),(_vm.showDashboard)?_c('div',{staticClass:"main-editor-side",class:{'show': _vm.isMobileSideBarShow}},[_c('MainSideBar')],1):_vm._e(),_c('div',{staticClass:"main-editor-main"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }